module.exports = __webpack_public_path__ + "static/pic03@3xwebp-1d8310f00a8000da2eef90de2cba51a2.webp";